import withStyles from "isomorphic-style-loader/withStyles";
import React from "react";
import styles from "../../styles.scss";
import { Button, ButtonGroup } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBold,
  faItalic,
  faLink,
  faListDots,
  faUnderline,
} from "@fortawesome/free-solid-svg-icons";

interface RTEEditorButtonsProps {
  isInlineStyleActive: Function;
  toggleInlineStyle: Function;
  allowList: boolean;
  allowLink?: boolean;
  isLinkActive?: boolean;
  onLinkClick?: () => void;
  isBlockTypeActive?: Function;
  toggleBlockType?: Function;
}

const RTEEditorButtons = ({
  isInlineStyleActive,
  toggleInlineStyle,
  allowList,
  allowLink,
  isLinkActive,
  onLinkClick,
  isBlockTypeActive,
  toggleBlockType,
}: RTEEditorButtonsProps) => {
  return (
    <ButtonGroup className="btn-group no-hover">
      <Button
        size="sm"
        style={{
          backgroundColor: isInlineStyleActive("BOLD") ? "#E2E8F0" : "#fff",
        }}
        className={styles.controlButton}
        onClick={() => toggleInlineStyle("BOLD")}
      >
        <FontAwesomeIcon icon={faBold} />
      </Button>
      <Button
        size="sm"
        style={{
          backgroundColor: isInlineStyleActive("ITALIC") ? "#E2E8F0" : "#fff",
        }}
        className={styles.controlButton}
        onClick={() => toggleInlineStyle("ITALIC")}
      >
        <FontAwesomeIcon icon={faItalic} />
      </Button>
      <Button
        size="sm"
        style={{
          backgroundColor: isInlineStyleActive("UNDERLINE")
            ? "#E2E8F0"
            : "#fff",
        }}
        className={styles.controlButton}
        onClick={() => toggleInlineStyle("UNDERLINE")}
      >
        <FontAwesomeIcon icon={faUnderline} />
      </Button>

      {allowLink && (
        <>
          <div
            style={{
              width: "1px",
              height: "32px",
              backgroundColor: "#E2E8F0",
              margin: "0 8px",
            }}
          />
          <Button
            size="sm"
            style={{
              backgroundColor: isLinkActive ? "#E2E8F0" : "#fff",
            }}
            className={styles.controlButton}
            onClick={onLinkClick}
          >
            <FontAwesomeIcon icon={faLink} />
          </Button>
        </>
      )}

      {allowList && (
        <>
          <div
            style={{
              width: "1px",
              height: "32px",
              backgroundColor: "#E2E8F0",
              margin: "0 8px",
            }}
          />
          <Button
            size="sm"
            style={{
              backgroundColor: isBlockTypeActive("unordered-list-item")
                ? "#E2E8F0"
                : "#fff",
            }}
            className={styles.controlButton}
            onClick={() => toggleBlockType("unordered-list-item")}
          >
            <FontAwesomeIcon icon={faListDots} />
          </Button>
        </>
      )}
    </ButtonGroup>
  );
};

export default withStyles(styles)(RTEEditorButtons);
